import { VChip } from 'vuetify/lib/components/VChip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VChip,
    {
      staticClass: "map-button",
      attrs: { color: "bg-primary", "text-color": "primary", label: "" },
      on: { click: _vm.openMap },
    },
    [
      _c("span", { staticClass: "text-body-1 font-weight-medium" }, [
        _vm._v("На карте"),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }